import React from "react";
import Classes from "./ImgLoader.module.css";

const ImgLoader = () => {
	return <div className={Classes.imgLoader}>Loading...</div>;
};

export default ImgLoader;
